import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from '../../features/app-setting/redux/actions';
import { bindActionCreators } from 'redux';
import BarSpinner from './loaders/BarSpinner';
import BounceSpiner from './loaders/BounceSpiner';
import ChaseDotSpinner from './loaders/ChaseDotSpinner';
import DotSpinner from './loaders/DotSpinner';
import FadingCircleSpinner from './loaders/FadingCircleSpinner';
import NoSpinner from './loaders/NoSpinner';
import Placeholder from './loaders/Placeholder';
import PlaneSpinner from './loaders/PlaneSpinner';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
import ParentContentCard from '../common/ParentContentCard';
import ParentDocCard from '../common/ParentDocCard';
import DocsLink from '../../common/custom/DocsLink';
import VideoBox from '../../common/custom/VideoBox';
import { loadingIconText } from '../../common/docs/content';
export class ShowDifferentLoader extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    selectedLoading: '',
  };

  changeSelectedLoading = (selectedLoading) => {
    this.setState({ selectedLoading });
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
  }

  handleProjectLoadinIconChange = async () => {
    const { actions, match } = this.props;
    const { projectId, version } = match.params;
    const { selectedLoading } = this.state;
    await actions.changeProjectLoadingIcon({ projectId, version, loadingIconKey: selectedLoading });
  };
  showUpdateButtonForLoadingCode = () => {
    const { appSetting } = this.props;
    const { selectedLoading } = this.state;
    const { projectDetail } = appSetting;
    if (!projectDetail) {
      return '';
    }
    const { loadingIconKey } = projectDetail;

    if (selectedLoading && loadingIconKey !== selectedLoading) {
      return (
        <div className="row">
          <div className="col-md-12 text-right">
            <button
              className="btn btn-theme-submit btn-md"
              onClick={this.handleProjectLoadinIconChange}
            >
              {loadingIconKey ? 'Update' : 'Save'}
            </button>
          </div>
        </div>
      );
    }
    return '';
  };

  render() {
    const { appSetting } = this.props;
    const { projectDetail } = appSetting;
    if (!projectDetail) {
      return <div>Loading...</div>;
    }
    const { loadingIconKey } = projectDetail;
    const { selectedLoading } = this.state;

    const selectedLoadingIcon = selectedLoading
      ? selectedLoading
      : loadingIconKey
      ? loadingIconKey
      : '';

    return (
      <CommonPageComponent>
        <AppSettingsNav activeTab={'loadingIcon'} projectDetail={projectDetail} />
        <ParentContentCard
          title="Default Loading Icon"
          bgColor="drapcode-violet"
          icon="loadingIcon"
        >
          <div className="row">
            <Placeholder
              selectedLoading={selectedLoadingIcon}
              changeSelectedLoading={this.changeSelectedLoading}
            />
            <PlaneSpinner
              selectedLoading={selectedLoadingIcon}
              changeSelectedLoading={this.changeSelectedLoading}
            />
            <ChaseDotSpinner
              selectedLoading={selectedLoadingIcon}
              changeSelectedLoading={this.changeSelectedLoading}
            />
            <BarSpinner
              selectedLoading={selectedLoadingIcon}
              changeSelectedLoading={this.changeSelectedLoading}
            />
            <DotSpinner
              selectedLoading={selectedLoadingIcon}
              changeSelectedLoading={this.changeSelectedLoading}
            />
            <FadingCircleSpinner
              selectedLoading={selectedLoadingIcon}
              changeSelectedLoading={this.changeSelectedLoading}
            />
            <BounceSpiner
              selectedLoading={selectedLoadingIcon}
              changeSelectedLoading={this.changeSelectedLoading}
            />
            <NoSpinner
              selectedLoading={selectedLoadingIcon}
              changeSelectedLoading={this.changeSelectedLoading}
            />
          </div>
          {this.showUpdateButtonForLoadingCode()}
        </ParentContentCard>
        <ParentDocCard>
          <h5>
            <b>About Default Loading Icon</b>
          </h5>
          <p>{loadingIconText}</p>
          <DocsLink link="https://academy.drapcode.com/docs/app-collection/changing-default-data-loading-icon" />
          <br />
          <h5>
            <b>Video</b>
          </h5>
          <VideoBox
            heading="Changing Default Data Login Icon View Video"
            imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/Changing+Default+Data+Login+Icon.jpg"
            videoLink="https://www.youtube.com/watch?v=tXrPvyREUs4"
          />
        </ParentDocCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ShowDifferentLoader);
